/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import EditableCard from 'modules/common/editableCard.component';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { updateGlobalVisaAndVaccine } from 'modules/authorizations/store/actions/global.actions';
import { PUT_GLOBAL_VISA_VACCINE_FAILURE } from 'modules/authorizations/store/types/globalTypes';
import { getGlobalInfo } from 'modules/authorizations/authorizations.actions';
import { showToast } from 'modules/layout/layout.actions';
import { toDateOrNull } from './visaTab.component';

const ImmunizationCard = props => {
  const [isLoading, setIsLoading] = useState(false);
  const { globalInfo, authId, isReadOnly, familyMemberId, globalId } = props;

  const tabs = [{ header: 'Permit and Immunization', order: 1, iconPath: ['fas', 'syringe'] }];

  const summaries = [
    {
      header: 'Work Permit',
      accessorKey: 'isWorkPermit',
      type: 'checkbox',
      required: false,
      value: !!globalInfo?.isWorkPermit,
      tab: 1
    },
    {
      header: 'Work Permit Acquired',
      accessorKey: 'workPermitAcquiredDate',
      type: 'date',
      required: false,
      value: globalInfo?.workPermitAcquiredDate ?? '',
      disableWhenModal: ({ values }) => !values.isWorkPermit,
      clearWhenDisabled: true,
      tab: 1
    },
    {
      header: 'Residency Permit',
      accessorKey: 'isResidencyPermit',
      type: 'checkbox',
      required: false,
      value: !!globalInfo?.isResidencyPermit,
      tab: 1
    },
    {
      header: 'Residency Permit Acquired',
      accessorKey: 'residencyPermitAcquiredDate',
      type: 'date',
      required: false,
      value: globalInfo?.residencyPermitAcquiredDate ?? '',
      disableWhenModal: ({ values }) => !values.isResidencyPermit,
      clearWhenDisabled: true,
      tab: 1
    },
    {
      header: 'Immunization Required',
      accessorKey: 'isImmunizationRequired',
      type: 'checkbox',
      required: false,
      value: !!globalInfo?.isImmunizationRequired,
      tab: 1
    },
    {
      header: 'Immunization Filed Date',
      accessorKey: 'immunizationFiledDate',
      type: 'date',
      required: false,
      value: globalInfo?.immunizationFiledDate ?? '',
      disableWhenModal: ({ values }) => !values.isImmunizationRequired,
      clearWhenDisabled: true,
      tab: 1
    }
  ];

  const updateFields = async (_tab, values) => {
    setIsLoading(true);

    const dto = {
      ...globalInfo,
      familyMemberId: Number(familyMemberId) || null,
      isWorkPermit: !!values.isWorkPermit,
      isResidencyPermit: !!values.isResidencyPermit,
      isImmunizationRequired: !!values.isImmunizationRequired,
      workPermitAcquiredDate: toDateOrNull(values.workPermitAcquiredDate),
      residencyPermitAcquiredDate: toDateOrNull(values.residencyPermitAcquiredDate),
      immunizationFiledDate: toDateOrNull(values.immunizationFiledDate)
    };

    const resp = await props.updateGlobalVisaAndVaccine(authId, globalId, familyMemberId, dto);

    if (resp?.type === PUT_GLOBAL_VISA_VACCINE_FAILURE) {
      props.showToast('Failed to update permit/immunization info, please try again.', {
        severity: TOAST_MESSAGE_SEVERITY_ERROR
      });
      return false;
    } else {
      await props.getGlobalInfo(authId);
    }

    setIsLoading(false);
    return true;
  };

  return (
    <EditableCard
      tabs={tabs}
      summaries={summaries}
      numColumns={5}
      updateFields={updateFields}
      isLoading={isLoading}
      hideEdit={isReadOnly}
    />
  );
};

export default compose(
  connect(null, {
    updateGlobalVisaAndVaccine,
    getGlobalInfo,
    showToast
  })
)(ImmunizationCard);
